import Button from 'components/base/Button';
import React from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { useState } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const ActivateUser = () => {

  const location = useLocation();
  const { t } = useTranslation();

  // Query string
  const queryParams = new URLSearchParams(location.search);
  const user_id = queryParams.get('user_id');
  const activation_uuid = queryParams.get('activation_uuid');


  const [errors, setErrors] = useState<{
    password?: string,
    password2?: string,
    registration_error?: string,
    registration_error_detail?: string
  }>({});
  const [activationComplete, setActivationComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  // Function to handle input changes
  const handleInputChangePwd1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPassword(value);
  };
  const handleInputChangePwd2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPassword2(value);
  };


  const validateForm = (): boolean => {
    const newErrors: { password?: string, password2?: string } = {};
    let isValid = true;

    if (password === "") {
      newErrors.password = 'Password cannot be empty';
      isValid = false;
    }

    if (password2 === "") {
      newErrors.password2 = 'Password cannot be empty';
      isValid = false;
    }

    if (password !== password2) {
      newErrors.password2 = 'Passwords do not match';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {

    if (validateForm() == false) {
      return
    }

    setLoading(true);
    const newErrors: { registration_error?: string, registration_error_detail?: string } = {};

    const formData = new FormData();
    formData.append('userActivationData', JSON.stringify({ 'password': password, 'user_id': user_id, 'activation_uuid': activation_uuid }));
    try {
      const response = await apiClient.post(
        `/auth/user/activate`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setActivationComplete(response.data.success);

    } catch (error) {
      const message = handleAPIError(error);
      if (message) {
        newErrors.registration_error = t("ActivateUser.registration_error")
        newErrors.registration_error_detail = message;
        setErrors(newErrors);

      } else {
        // Handle non-Axios errors
        console.error('Request failed:', error);
      }

    } finally {
      setLoading(false);
    }

  };

  return (
    <div className="text-center mb-6">
      <h4 className="text-1000">{t("ActivateUser.activate_user")}</h4>
      <p className="text-700">{t("ActivateUser.type_passwords")}</p>

      {activationComplete === false && loading === false && (
        <Form className="mt-5">
          <Form.Group>
            <Form.Control
              className="mb-2"
              id="password"
              type="password"
              placeholder="Type new password"
              onChange={handleInputChangePwd1}
              isInvalid={!!errors.password}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mt-4'>
            <Form.Control
              className="mb-2"
              id="confirmPassword"
              type="password"
              placeholder="Confirm new password"
              onChange={handleInputChangePwd2}
              isInvalid={!!errors.password2}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password2}
            </Form.Control.Feedback>
          </Form.Group>
          <Button variant="primary" className="w-100 mt-4 mb-3" onClick={handleSubmit}>
            {t("ActivateUser.continue")}
          </Button>
        </Form>
      )}

      {activationComplete === false && loading === true && (
        <Spinner animation="grow" variant="primary" />
      )}

      {activationComplete === true && (
        <>
          <div className="text-center mb-7">
            <h3 className="text-1000">{t("ActivateUser.activation_complete")}</h3>
            <br />
            <h4 className="text-700">{t("ActivateUser.line1")}</h4>
            <br />
            <h4 className="text-700">{t("ActivateUser.line2")}</h4>

          </div>
        </>
      )}

      {!!errors.registration_error && (
        <>
          <div className="text-center  mt-2">
            <h3 className="text-1000 text-danger ">{errors.registration_error}</h3>
            <p className="text-1000 text-info ">{errors.registration_error_detail}</p>
          </div>

          <div className="text-center mt-2">
            <Link to={`mailto:onboarding@th-habitat.com`} className="fs-9 fw-bold">
              <h4 className="text-1000">{t("ActivateUser.contact_us")}</h4>
            </Link>
          </div>
        </>
      )
      }
    </div >
  );
};

export default ActivateUser;
